import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { TreeModule } from 'primeng/tree'
import { DocuemetContentType } from 'src/app/modules/document-managment/model/docuemetContentType'
import { HtmlToTextPipe } from '../../pipes/html-to-text.pipe'

@Component({
  selector: 'app-document-view-details',
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipe,
    FormsModule,
    TreeModule,
    HtmlToTextPipe
  ],
  standalone: true,
  templateUrl: './document-view-details.html',
  styleUrl: './document-view-details.scss'
})
export class DocumentViewDetails {
  @Input() documentDetails: any
  @Input() items: any[] = []
  @Input() moduleTranslationPrifix!: string
  @Input() originalTree: any[] = []
  @Input() contentList: any[] = []
  @Input() showAcknowledge: boolean = false
  @Input() viewApprovment: boolean = false

  @Output() submitEvent = new EventEmitter<void>()
  @Output() searchChangedEvent = new EventEmitter<string>()
  @Output() downloadEvent = new EventEmitter<string>()
  currentLanguage = localStorage.getItem('lang')
  isContentView: boolean = true
  searchVal: string = ''

  getNodeClass(node: any): string {
    if (node.contentType === DocuemetContentType.Container) {
      return node.parentId ? 'sub-parent' : 'parent'
    }
    if (node.contentType === DocuemetContentType.Item) {
      return 'child'
    }
    return ''
  }

  showHideContent() {
    this.isContentView = !this.isContentView
  }

  onSearch(query: any) {
    this.searchVal = query
    this.searchChangedEvent.emit(query)
  }

  downLoadFile(item: string) {
    this.downloadEvent.emit(item)
  }

  onSubmit() {
    this.submitEvent.emit()
  }
}
